module.exports = __webpack_public_path__ + "img/engine.1a2b1f8d.svg";